module.exports = __webpack_public_path__ + "static/media/airplane_honeymoon.f141e5a6.svg";